var localizedDetails = function() {

	var color = "color";
	var colorCap = "Color";

	var invalidQuestionMsg = "Questions need to be longer than 5 characters";
	var invalidAnswerMsg = "Answers must be longer than 1 character";

	var phoneNumber = '1-877-446-7746';
	
	var showCustomerImages = true;
	
	return {
		Color: color,
		ColorCap: colorCap,
		InvalidQuestionMsg: invalidQuestionMsg,
		InvalidAnswerMsg: invalidAnswerMsg,
		PhoneNumber: phoneNumber,
		showCustomerImages: showCustomerImages
	};
};